import { ItiBaseDto } from '@/iti-core-vue';

export class Message extends ItiBaseDto {
    public _id!: number;
    public content!: string;
    public senderId!: number;
    public username!: string;
    public avatar!: string;
    public dateTime!: Date;
    public date!: string;
    public timestamp!: string;
    public system!: boolean;
    public saved!: boolean;
    public distributed!: boolean;
    public seen!: boolean;
    public new!: boolean;
    public disableActions!: boolean;
    public disableReactions!: boolean;
    public roomId!: number;
}
